module.exports = __webpack_public_path__ + "static/media/bocongthuong2.d032db55.svg";